import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { setHasImportantUnsavedChanges } from '@rd-web-markets/shared/dist/store/features/unsavedChangesSlice';
import ReportNotesForm from '../summarySection/ProjectNotesForm';
import ReportNotesTable from '../summarySection/ProjectNotesTable';
const ActivitiesCommentsList = _ref => {
  let {
    report,
    setReport,
    pageAccess,
    reportNotesHandlers
  } = _ref;
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const currentUser = useSelector(state => state.auth.user);
  const {
    notes,
    setNotes,
    createNote,
    updateNote,
    deleteNote,
    loading
  } = reportNotesHandlers;
  useEffect(() => {
    if (report.report_notes) {
      setNotes(report.report_notes);
    }
  }, [report.id, report.report_notes?.length]);
  const handleCreateNote = async formData => {
    try {
      const response = await createNote(formData);
      const updatedNotes = [response, ...notes];
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport({
        ...report
      });
      dispatch(setHasImportantUnsavedChanges(false));
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const handleUpdateNote = async _ref2 => {
    let {
      id,
      data
    } = _ref2;
    try {
      const response = await updateNote({
        id,
        data
      });
      const updatedNotes = notes.map(n => n.id === id ? response : n);
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport({
        ...report
      });
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const handleDeleteNote = async noteId => {
    try {
      await deleteNote(noteId);
      const updatedNotes = notes.filter(n => n.id !== noteId);
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport({
        ...report
      });
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReportNotesForm, {
    loading: loading,
    onSubmit: handleCreateNote,
    noteType: "project_notes",
    isImmutableUnderReview: false
  }), /*#__PURE__*/React.createElement(ReportNotesTable, {
    notes: notes,
    onUpdate: handleUpdateNote,
    onDelete: handleDeleteNote,
    userCanEdit: true,
    loading: loading,
    filterByType: "project_notes",
    showTypeColumn: false,
    currentUserId: currentUser?.id
  }));
};
export default ActivitiesCommentsList;